import './Tag.scss';

import * as React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

type Props = {
  tag: string;
  to: string;
  inverted?: boolean;
};

function Tag(props: Props) {
  return (
    <Link
      className={classnames('Tag', {
        'Tag--inverted': props.inverted === true,
      })}
      to={props.to}
    >
      {props.tag}
    </Link>
  );
}

Tag.defaultProps = { inverted: false };

export default Tag;
